export const META_PIXEL_ID = '1339974394886632'

type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  push: MetaPixelFunction
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: MetaPixelFunction
    _fbq?: MetaPixelFunction
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const pixel = function (...args: unknown[]) {
    if (pixel.callMethod) {
      pixel.callMethod(...args)
      return
    }

    pixel.queue.push(args)
  } as MetaPixelFunction

  pixel.queue = []
  pixel.push = pixel
  pixel.loaded = true
  pixel.version = '2.0'

  window.fbq = pixel
  window._fbq = pixel

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackMetaAddToCart(): void {
  window.fbq?.('track', 'AddToCart')
}
